import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { FunctionButton } from '@pulse-web-ui/button-v2';
import { observer } from 'mobx-react-lite';

import { sendAnalyticEvent } from '@app/web-analytic';

import { ABOUT, AnalyticEvent } from '@shared/constants';
import { useStores } from '@shared/hooks';
import { WidgetHeader } from '@shared/ui';
import { addTestAttribute } from '@shared/utils';

import { ProductList } from '../product-list';
import { RewardHint } from './main-products.styles';

export const MainProducts = observer(() => {
  const { t } = useTranslation();
  const {
    MainStore: {
      agentUserStore: { availableSign },
    },
  } = useStores();

  const handleMoreAboutProductsClick = useCallback(() => {
    sendAnalyticEvent(AnalyticEvent.AGENT_MOREDETAILS, {
      isagent: availableSign?.visibilityDocuments ? 'n' : 'y',
    });
    window.open(ABOUT, '_blank');
  }, [availableSign]);

  return (
    <div>
      <WidgetHeader $marginBottom={24}>
        {t('PRODUCTS:headers.newProduct')}
      </WidgetHeader>
      <ProductList />
      <RewardHint>{t('CHOOSE_PRODUCT:hints.rewardHint')}</RewardHint>
      <FunctionButton
        variant='primary'
        size='s'
        onClick={handleMoreAboutProductsClick}
        {...addTestAttribute('more-about-products-button')}
      >
        {t('CHOOSE_PRODUCT:buttons.moreAboutProducts')}
      </FunctionButton>
    </div>
  );
});
